import { render } from "./ListaPedidosEntreguesView.vue?vue&type=template&id=508dcb9f&scoped=true"
import script from "./ListaPedidosEntreguesView.vue?vue&type=script&lang=js"
export * from "./ListaPedidosEntreguesView.vue?vue&type=script&lang=js"

import "./ListaPedidosEntreguesView.vue?vue&type=style&index=0&id=508dcb9f&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Domus Fiança\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508dcb9f"]])

export default __exports__